import React, { useEffect, useRef } from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import css from './FaqContent.module.css';

const isQuestionParagraph = el => {
  if (el.tagName !== 'P') return false;
  const strong = el.querySelector('strong');
  if (!strong) return false;
  const text = strong.textContent.trim();
  return text.endsWith('?') || text === text.toUpperCase();
};

export const FaqContent = ({ children, className }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const container = containerRef.current;
    const textContainers = container.querySelectorAll('[class*="BlockDefault_text"]');

    textContainers.forEach(textContainer => {
      const elements = Array.from(textContainer.children);
      const newContent = document.createDocumentFragment();
      let i = 0;

      while (i < elements.length) {
        const el = elements[i];

        if (isQuestionParagraph(el)) {
          const content = [];
          let j = i + 1;
          while (
            j < elements.length &&
            !isQuestionParagraph(elements[j]) &&
            !elements[j].matches('h1, h2, h3, h4, h5, h6')
          ) {
            content.push(elements[j]);
            j++;
          }

          if (content.length > 0) {
            const details = document.createElement('details');
            details.className = css.faqItem;

            const summary = document.createElement('summary');
            summary.className = css.faqQuestion;
            const questionText = el.querySelector('strong').textContent;
            summary.appendChild(document.createTextNode(questionText));

            const icon = document.createElement('span');
            icon.className = css.faqIcon;
            icon.setAttribute('aria-hidden', 'true');
            summary.appendChild(icon);

            details.appendChild(summary);

            const answerDiv = document.createElement('div');
            answerDiv.className = css.faqAnswer;
            content.forEach(c => answerDiv.appendChild(c.cloneNode(true)));
            details.appendChild(answerDiv);

            newContent.appendChild(details);
            i = j;
          } else {
            newContent.appendChild(el.cloneNode(true));
            i++;
          }
        } else {
          newContent.appendChild(el.cloneNode(true));
          i++;
        }
      }

      textContainer.innerHTML = '';
      textContainer.appendChild(newContent);
    });
  }, []);

  return (
    <div ref={containerRef} className={classNames(css.faqContainer, className)}>
      {children}
    </div>
  );
};

FaqContent.defaultProps = {
  className: null,
  children: null,
};

FaqContent.propTypes = {
  className: string,
  children: node,
};

export default FaqContent;
